import { Component, DestroyRef, OnInit, inject } from '@angular/core';
import {
  UntypedFormArray,
  UntypedFormBuilder,
  UntypedFormGroup,
  ReactiveFormsModule,
} from '@angular/forms';
import { CommonResources } from '@resources/ru/commonModule/common.resources';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

interface Reason {
  code: string;
  value: string;
  hint?: string;
}

@Component({
  templateUrl: './modalReason.component.html',
  styleUrls: ['./modalReason.component.scss'],
  imports: [ReactiveFormsModule],
})
export class ModalReasonComponent implements OnInit {
  dialogRef = inject<MatDialogRef<ModalReasonComponent>>(MatDialogRef);
  data = inject<{
    reasons: Reason[];
    title: string;
  }>(MAT_DIALOG_DATA);
  formBuilder = inject(UntypedFormBuilder);
  private readonly destroyRef = inject(DestroyRef);

  public reasons: Reason[];
  public commonResources: CommonResources = new CommonResources();
  public notePlaceholder: string = this.commonResources.refineAnswer;
  public form: UntypedFormGroup;
  public isButtonDisabled: boolean = true;

  constructor() {
    const data = this.data;

    this.reasons = data.reasons;
  }

  ngOnInit(): void {
    this.form = this.formBuilder.group({
      checkboxes: this.buildCheckboxes(),
      comment: [''],
    });

    this.form.valueChanges
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(() => {
        this.isButtonDisabled = !this.isCheckboxSelected();
      });
  }

  buildCheckboxes(): UntypedFormArray {
    const checkboxArray = this.reasons.map(() => false);
    return this.formBuilder.array(checkboxArray);
  }

  isCheckboxSelected(): boolean {
    const checkboxes = this.form.value.checkboxes;
    return checkboxes.some((value: boolean) => value);
  }

  onCheckboxChange(checked: boolean, reason: Reason): void {
    if (checked && reason?.hint) {
      this.notePlaceholder = reason.hint;
    } else {
      this.notePlaceholder = this.commonResources.refineAnswer;
    }
  }

  public onSubmit(): void {
    const selectedCheckboxes = this.form.value.checkboxes
      .map((checked: boolean, index: number) =>
        checked ? this.reasons[index].code : null
      )
      .filter((reason: Reason) => reason !== null);

    const result = {
      rejectedReasonIdList: selectedCheckboxes,
      comment: this.form.value.comment,
    };

    this.dialogRef.close(result);
  }

  public close(): void {
    this.dialogRef.close();
  }
}
